 /* Declare Styles */
 export default theme => ({
  main: {
    display: 'block', // Fix IE 11 issue.
    marginLeft: 0,
    marginRight: 0,
    padding:0,
    width: '100%',
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`,
    [theme.breakpoints.down(600 + theme.spacing(3) * 2)]: {
      marginTop:0,
      minHeight: '100vh',
    },
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: '#fff',
    width:'100px',
    height:'100px',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  submit: {
    marginTop: theme.spacing(3),
  },
  role:{ 
    fontSize: 25,
    width: '96%',
    minWidth:200,
    margin: '2%',
    height: 90,
    [theme.breakpoints.down(600 + theme.spacing(3) * 2)]: {
      width: '96%',
    },
  },
  orSocialMediaText: {
    display: 'flex',
    fontSize: '14px',
    '&::before': {
      background: '#dfdfd7',
      flex: '1 1',
      height: '1px',
      content: '""',
      alignSelf: 'center',
      marginRight: '10px'
    },
    '&::after': {
      background: '#dfdfd7',
      flex: '1 1',
      height: '1px',
      content: '""',
      alignSelf: 'center',
      marginLeft: '10px'
    },
  }
});